export default __webpack_public_path__ + "static/candido-ba963ba6949de41f3139aaeb6d01e8e7.jpg";